import { useParams } from "react-router-dom"
import PageNotFound from "../../../pages/PageNotFound"
import { Article } from "../../../ui/atoms/Article"
import { Container } from "../../../ui/atoms/Container"
import { LazyVideo } from "../../projects/component/atoms/LazyVideo"
import useFetchCampaignBySlug from "../hooks/useFetchCompaignBySlug"
import { Brand } from "../../../ui/header/Brand"
import { ControlsVideos } from "../components/organism/ControlsVideos"
import { useState } from "react"
import { PrevAndNextCampaign } from "../components/organism/PrevAndNextCampaign"
import useMobile from "../../../hooks/useMobile"
import { motion, AnimatePresence } from "framer-motion"
import { ContentCustom } from "../../../ui/organisms/ContentCustom"

export const ShowCampaign = () => {
    // Controls video
    const [isPlayed, setIsPlayed] = useState(true);
    const [isMuted, setIsMuted] = useState(false);

    const isMobile = useMobile();

    const { slug } = useParams();
    
    const { data, error } = useFetchCampaignBySlug(slug)

    if (error) return <PageNotFound />

    return (
        <Article className="h-screen">
            <Container className="lg:w-10/12 w-full h-screen flex items-stretch justify-center relative ">
                
                <div className="z-10 lg:w-fit w-10/12 absolute lg:left-0 h-24 flex justify-start items-stretch">
                    <div className="w-full grow flex items-center justify-between text-orange-600">
                        <Brand title />
                        {isMobile && data.video && 
                            <ControlsVideos 
                                isPlayed={isPlayed}
                                setIsPlayed={setIsPlayed}
                                isMuted={isMuted} 
                                setIsMuted={setIsMuted}
                            />
                        }
                        
                    </div>
                </div>
                
                <AnimatePresence initial={false} mode="wait">
                    <motion.div 
                        className="w-[600px] h-full relative"
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                        transition={{opacity: { type: "spring", stiffness: 300, damping: 40 }}}
                 
                    >
                        {/* Header menu */}
                        {!isMobile && data.video && 
                            <div className="z-10 lg:w-10/12 absolute lg:left-1/2 transofrm lg:-translate-x-1/2 h-24 flex justify-end items-stretch">
                                <ControlsVideos 
                                    isPlayed={isPlayed}
                                    setIsPlayed={setIsPlayed}
                                    isMuted={isMuted} 
                                    setIsMuted={setIsMuted}
                                />
                            </div>
                        }

                        <ContentCustom data={data} />

                        <>
                        {(data.mainImage && !data.video) &&
                            <div className="w-full h-screen">
                                <figure className="w-full h-screen">
                                    <img 
                                        className="w-full h-full object-cover" 
                                        src={`${process.env.REACT_APP_URL_CLOUDFARE}images/${data.mainImage}.webp`} 
                                        alt={data.title}
                                    />
                                </figure>
                            </div>
                        }


                        { data.video &&
                            <LazyVideo 
                                videoSrc={`${process.env.REACT_APP_URL_CLOUDFARE}video/${data.video}`} 
                                isMuted={isMuted}
                                isPlayed={isPlayed}
                                setIsPlayed={setIsPlayed}    
                            />
                        }

                        <div className="z-10 absolute w-full left-0 bottom-0 h-52 bg-gradient-to-t from-10% from-black to-transparent"></div>
                        </>
                        
                    </motion.div>
                </AnimatePresence>
            
                <PrevAndNextCampaign />
            </Container>
        </Article>
    )
}